import { countryToCurrency, Currency } from './currency';
export var Country;
(function (Country) {
    Country["AU"] = "au";
    Country["CA"] = "ca";
    Country["CH"] = "ch";
    Country["ES"] = "es";
    Country["ID"] = "id";
    Country["IE"] = "ie";
    Country["IT"] = "it";
    Country["GB"] = "gb";
    Country["MY"] = "my";
    Country["NO"] = "no";
    Country["SG"] = "sg";
    Country["US"] = "us";
})(Country || (Country = {}));
export const localeCountries = {
    CA: Country.CA,
    CH: Country.CH,
    ES: Country.ES,
    ID: Country.ID,
    IE: Country.IE,
    IT: Country.IT,
    US: Country.US,
    GB: Country.GB,
    MY: Country.MY,
    NO: Country.NO,
    SG: Country.SG,
    AU: Country.AU
};
export const getUserCountry = () => {
    var _a;
    const locale = Intl.DateTimeFormat().resolvedOptions().locale;
    const localeSuffix = locale.slice(-2);
    return (_a = localeCountries[localeSuffix]) !== null && _a !== void 0 ? _a : Country.US;
};
export const getUserCurrency = () => {
    var _a;
    return (_a = countryToCurrency[getUserCountry()]) !== null && _a !== void 0 ? _a : Currency.USD;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291bnRyeS5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJjb3VudHJ5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxRQUFRLEVBQUUsTUFBTSxZQUFZLENBQUE7QUFFeEQsTUFBTSxDQUFOLElBQVksT0FhWDtBQWJELFdBQVksT0FBTztJQUNqQixvQkFBUyxDQUFBO0lBQ1Qsb0JBQVMsQ0FBQTtJQUNULG9CQUFTLENBQUE7SUFDVCxvQkFBUyxDQUFBO0lBQ1Qsb0JBQVMsQ0FBQTtJQUNULG9CQUFTLENBQUE7SUFDVCxvQkFBUyxDQUFBO0lBQ1Qsb0JBQVMsQ0FBQTtJQUNULG9CQUFTLENBQUE7SUFDVCxvQkFBUyxDQUFBO0lBQ1Qsb0JBQVMsQ0FBQTtJQUNULG9CQUFTLENBQUE7QUFDWCxDQUFDLEVBYlcsT0FBTyxLQUFQLE9BQU8sUUFhbEI7QUFFRCxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQTRCO0lBQ3RELEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtJQUNkLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtJQUNkLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtJQUNkLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtJQUNkLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtJQUNkLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtJQUNkLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtJQUNkLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtJQUNkLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtJQUNkLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtJQUNkLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtJQUNkLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtDQUNmLENBQUE7QUFJRCxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsR0FBWSxFQUFFOztJQUMxQyxNQUFNLE1BQU0sR0FBRyxJQUFJLENBQUMsY0FBYyxFQUFFLENBQUMsZUFBZSxFQUFFLENBQUMsTUFBTSxDQUFBO0lBQzdELE1BQU0sWUFBWSxHQUFHLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtJQUNyQyxPQUFPLE1BQUEsZUFBZSxDQUFDLFlBQVksQ0FBQyxtQ0FBSSxPQUFPLENBQUMsRUFBRSxDQUFBO0FBQ3BELENBQUMsQ0FBQTtBQUVELE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyxHQUFhLEVBQUU7O0lBQzVDLE9BQU8sTUFBQSxpQkFBaUIsQ0FBQyxjQUFjLEVBQUUsQ0FBQyxtQ0FBSSxRQUFRLENBQUMsR0FBRyxDQUFBO0FBQzVELENBQUMsQ0FBQSJ9